import { Component, ChangeDetectionStrategy, ElementRef, signal, viewChild, inject, effect, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { AppSettingsDialog } from './components/app-settings-dialog/app-settings-dialog';
import { GpuWorkerDialog } from './components/gpu-worker-dialog/gpu-worker-dialog';
import { WorkerExecutionPreferenceService } from './services/worker-execution-preference.service';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  imports: [RouterModule, NgOptimizedImage, AppSettingsDialog, GpuWorkerDialog],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {
  private readonly workerTrigger = viewChild<ElementRef<HTMLButtonElement>>('workerTrigger');
  private readonly settingsTrigger = viewChild<ElementRef<HTMLButtonElement>>('settingsTrigger');
  private readonly executionPreferences = inject(WorkerExecutionPreferenceService);

  readonly appVersion = packageJson.version;
  readonly workerDialogOpen = signal(false);
  readonly settingsOpen = signal(false);
  readonly executionPreference = signal(this.executionPreferences.getExecutionPreference());

  readonly executionTargetLabel = computed(() => {
    return this.executionPreference() === 'runpod' ? 'GPU' : 'CPU';
  });

  constructor() {
    effect(() => {
      if (!this.workerDialogOpen()) {
        // Refresh the preference when dialog closes in case it was changed
        this.executionPreference.set(this.executionPreferences.getExecutionPreference());
      }
    });
  }

  openWorkerDialog(): void {
    this.workerDialogOpen.set(true);
  }

  closeWorkerDialog(): void {
    this.workerDialogOpen.set(false);
    queueMicrotask(() => this.workerTrigger()?.nativeElement.focus());
  }

  openSettings(): void {
    this.settingsOpen.set(true);
  }

  closeSettings(): void {
    this.settingsOpen.set(false);
    queueMicrotask(() => this.settingsTrigger()?.nativeElement.focus());
  }
}
